/**
 * Configuration for portfolio usage and status options
 */

// Portfolio usage options for dropdown menus
export const PORTFOLIO_USAGE_OPTIONS = [
  { key: 'audiobook', text: 'Audiobook Series', value: 'Audiobook Series' },
  { key: 'video_game', text: 'Video Game', value: 'Video Game' },
  { key: 'animation', text: 'Animation Series', value: 'Animation Series' },
  { key: 'documentary', text: 'Documentary Series', value: 'Documentary Series' },
  { key: 'commercial', text: 'Commercial', value: 'Commercial' },
  { key: 'podcast', text: 'Podcast', value: 'Podcast' },
  { key: 'film', text: 'Film', value: 'Film' },
  { key: 'other', text: 'Other', value: 'Other' }
];

// Portfolio status options for dropdown menus
export const PORTFOLIO_STATUS_OPTIONS = [
  { key: 'active', text: 'Active', value: 'Active' },
  { key: 'in_development', text: 'In Development', value: 'In Development' },
  { key: 'completed', text: 'Completed', value: 'Completed' },
  { key: 'on_hold', text: 'On Hold', value: 'On Hold' },
  { key: 'cancelled', text: 'Cancelled', value: 'Cancelled' }
];

// Default values
export const DEFAULT_PORTFOLIO_USAGE = 'Audiobook Series';
export const DEFAULT_PORTFOLIO_STATUS = 'Active';

// Color mappings for portfolio status values
export const PORTFOLIO_STATUS_COLORS = {
  'Active': 'green',
  'In Development': 'orange',
  'Completed': 'blue',
  'On Hold': 'grey',
  'Cancelled': 'red'
};

// Helper function to get portfolio status color
export const getPortfolioStatusColor = (status) => {
  return PORTFOLIO_STATUS_COLORS[status] || PORTFOLIO_STATUS_COLORS[DEFAULT_PORTFOLIO_STATUS];
};

// Usage icons mapping
export const PORTFOLIO_USAGE_ICONS = {
  'Audiobook Series': 'book',
  'Video Game': 'gamepad',
  'Animation Series': 'film',
  'Documentary Series': 'video',
  'Commercial': 'bullhorn',
  'Podcast': 'microphone',
  'Film': 'film',
  'Other': 'question'
};

// Helper function to get portfolio usage icon
export const getPortfolioUsageIcon = (usage) => {
  return PORTFOLIO_USAGE_ICONS[usage] || PORTFOLIO_USAGE_ICONS[DEFAULT_PORTFOLIO_USAGE];
};
